import { Activity } from "../types/activity";
import { PalletLayer } from "../types/palletLayer";

const getPalletLayers = (activity: Activity): PalletLayer[] => {
    var layers: PalletLayer[] = [];
    if (activity.layerCount === 0) {
        layers.push({ layersCount: 1, piecesCount: activity.standardQty });
        return layers;
    }
    for (var i = 1; i <= activity.layerCount; i++)
        layers.push({ layersCount: i, piecesCount: i * (activity.standardQty/activity.layerCount) });

    return layers;
};

const getCustDescriptionField = (activity: Activity): string =>
   [activity.custMaterialCode, activity.customerCrossRefA, activity.customerCrossRefB, activity.customerCrossRefC].join(" ").trim();

export { getPalletLayers, getCustDescriptionField };
